import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Document, BLOCKS } from '@contentful/rich-text-types'

import css from './styles.scss'
import EmbedSocialMedia from '../Embeds/EmbedSocialMedia'

interface RichTextBodyProps {
  richTextBody: Document
  serverData: ServerData | undefined
}

const RichTextBody: React.FC<RichTextBodyProps> = ({
  richTextBody,
  serverData,
}) => {
  const richTextOptions = {
    renderNode: {
      [BLOCKS.EMBEDDED_ENTRY]: (node: any) => {
        try {
          if (!serverData) {
            return null
          }

          const id = node.data.target?.sys?.id

          if (!id) {
            return null
          }

          const type = node.data.target.sys?.contentType?.sys?.id as
            | string
            | undefined

          switch (type) {
            case 'video':
              if (node.data.target.fields?.url) {
                const videoId = new URL(
                  node.data.target.fields?.url
                ).searchParams.get('v')

                return (
                  <div className={css.Embed__Youtube}>
                    <iframe
                      src={`https://www.youtube.com/embed/${videoId}?feature=oembed&modestbranding=1&showinfo=0&rel=0&controls=1`}
                      title={node.data.target.fields?.title || ''}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    ></iframe>
                  </div>
                )
              }

              break
            case 'postEmbedSocialMedia':
              return (
                <EmbedSocialMedia
                  channel={node.data.target.fields?.channel}
                  embedCode={node.data.target.fields?.embedCode}
                />
              )
              break
            default:
              const item = serverData.embeddedEntries.find(
                (item) => item.id === id
              )

              if (item) {
                return <div dangerouslySetInnerHTML={{ __html: item.html }} />
              }
          }
        } catch (e) {
          console.log(e)
          return
        }
      },
      [BLOCKS.EMBEDDED_ASSET]: (node: any) => {
        try {
          const { url, description } = node.data.target
          return (
            <img
              alt={description}
              className="img-responsive"
              src={url}
              style={{ maxWidth: '100%' }}
            />
          )
        } catch (e) {
          console.log(e)
          return
        }
      },
    },
  }
  return <>{documentToReactComponents(richTextBody, richTextOptions)}</>
}

export default RichTextBody
